"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * @internal
 * Set HTML content to this editor. All existing content will be replaced. A ContentChanged event will be triggered
 * if triggerContentChangedEvent is set to true
 * @param core The EditorCore object
 * @param content HTML content to set in
 * @param triggerContentChangedEvent True to trigger a ContentChanged event. Default value is true
 */
exports.setContent = function (core, content, triggerContentChangedEvent) {
    var contentChanged = false;
    if (core.contentDiv.innerHTML != content) {
        core.api.triggerEvent(core, {
            eventType: 20 /* BeforeSetContent */,
            newContent: content,
        }, true /*broadcast*/);
        var range = roosterjs_editor_dom_1.setHtmlWithSelectionPath(core.contentDiv, content, core.trustedHTMLHandler);
        core.api.selectRange(core, range);
        contentChanged = true;
    }
    // Convert content even if it hasn't changed.
    core.api.transformColor(core, core.contentDiv, false /*includeSelf*/, null /*callback*/, 0 /* LightToDark */);
    if (triggerContentChangedEvent && (contentChanged || core.lifecycle.isDarkMode)) {
        core.api.triggerEvent(core, {
            eventType: 7 /* ContentChanged */,
            source: "SetContent" /* SetContent */,
        }, false /*broadcast*/);
    }
};
//# sourceMappingURL=setContent.js.map